import React from "react";
import clsx from "clsx";

interface FeedbackListProps {
  children: React.ReactNode;
  className?: string;
}

export function FeedbackList({ children, className }: FeedbackListProps) {
  const isEmpty = React.Children.count(children) === 0;

  return (
    <ul className={clsx("max-h-max space-y-3 overflow-auto md:max-h-[65dvh]", className)}>
      {isEmpty ? <li className="py-4 text-center text-gray-500">Empty</li> : children}
    </ul>
  );
}
